export default __webpack_public_path__ + "static/media/107t.ef830597.jpg";